import { isFeatureEnabled } from '../../utils/featureFlagHelper';

export const validateSignatureBlock = (htmlToValidate) => {
    if(!isFeatureEnabled('signatureValidation')) {
        return true; //skip validation if feature is not enabled
    }

    const hasESig = htmlToValidate.includes("[E-SIG]")
    if (!hasESig) {
        return false;
    }
    return true;
}


// WEBPACK FOOTER //
// ./src/validations/SignatureValidation/signatureValidation.js